import React from 'react'
import logo from '../../../assets/images/mobicom.png';
import { Link, useLocation } from 'react-router-dom';
import { IoHomeOutline } from "react-icons/io5";
import { MdKeyboardArrowRight, MdPrecisionManufacturing } from "react-icons/md";
import logomobi from '../../../assets/images/mobicom.png'
import { BiCategoryAlt } from 'react-icons/bi';
import { RiBarChartBoxLine } from 'react-icons/ri';
import { FaUsers } from 'react-icons/fa6';
import { FiChevronRight } from 'react-icons/fi';
import { HiOutlineDocumentReport } from "react-icons/hi";
import { BsClipboardData } from "react-icons/bs";


const Sidebar = () => {

    const location = useLocation();
    const user = JSON.parse(localStorage.getItem('user'));

    console.log(user, 'user');


    return (
        <div className="app-menu navbar-menu">
            <div>
                <div className="navbar-brand-box">
                    <Link to={'/'} className="logo logo-dark">
                        <span className="logo-sm">
                            <img src={logo} alt="" height={22} />
                        </span>
                        <span className="logo-lg">
                            <img src={logo} alt="" className='logo_tabs' />
                        </span>
                    </Link>

                    <button
                        type="button"
                        className="btn btn-sm p-0 fs-20 header-item float-end btn-vertical-sm-hover"
                        id="vertical-hover"
                    >
                        <i className="ri-record-circle-line" />
                    </button>
                </div>
                <div id="scrollbar">
                    <div className="container-fluid p-0">
                        <div id="two-column-menu" />
                        <ul className="navbar-nav" id="navbar-nav">
                            <li className={`nav-item ${location.pathname === '/' ? 'active' : ''}`}>
                                <Link to={'/'} className="nav-link menu-link" >
                                    <IoHomeOutline /> <span data-key="t-widgets">Dashboard</span>
                                </Link>
                            </li>

                            <li className={`nav-item ${location.pathname === '/header-email' ? 'active' : ''}`}>
                                <Link to={'/header-email'} className="nav-link menu-link" >
                                    <BiCategoryAlt /> <span data-key="t-widgets">Header</span>
                                </Link>
                            </li>

                            <li className={`nav-item ${location.pathname === '/template-email' ? 'active' : ''}`}>
                                <Link to={'/template-email'} className="nav-link menu-link" >
                                    <MdPrecisionManufacturing /> <span data-key="t-widgets">Template</span>
                                </Link>
                            </li>

                            <li className={`nav-item ${location.pathname === '/footer-email' ? 'active' : ''}`}>
                                <Link to={'/footer-email'} className="nav-link menu-link" >
                                    <RiBarChartBoxLine /> <span data-key="t-widgets">Footer</span>
                                </Link>
                            </li>

                            <li className={`nav-item ${location.pathname === '/reports' ? 'active' : ''}`}>
                                <Link to={'/reports'} className="nav-link menu-link" >
                                    <HiOutlineDocumentReport /> <span data-key="t-widgets">Reports</span>
                                </Link>
                            </li>
                            {/* <li className={`nav-item ${location.pathname === '/error-report' ? 'active' : ''}`}>
                                <Link to={'/error-report'} className="nav-link menu-link" >
                                    <HiOutlineDocumentReport /> <span data-key="t-widgets">Error Report</span>
                                </Link>
                            </li>
                            <li className={`nav-item ${location.pathname === '/sent-report' ? 'active' : ''}`}>
                                <Link to={'/sent-report'} className="nav-link menu-link" >
                                    <BsClipboardData  /> <span data-key="t-widgets">Sent Report</span>
                                </Link>
                            </li> */}
                            <li className="nav-item">
                                <a className="nav-link menu-link" href="#sidebarUsers" data-bs-toggle="collapse" role="button" aria-expanded="false" aria-controls="sidebarUsers">
                                    <FaUsers />
                                    <span data-key="t-dashboards">User Management</span>
                                    <div className='collapse-icon'><FiChevronRight /></div>
                                </a>
                                <div className="collapse menu-dropdown" id="sidebarUsers">
                                    <ul className="nav nav-sm flex-column">

                                        {/* <li className="nav-item">
                                            <Link to={'/roles'} className="nav-link" data-key="t-analytics">
                                                Roles
                                            </Link>
                                        </li> */}

                                        <li className="nav-item">
                                            <Link to={'/create-user'} className="nav-link" data-key="t-crm">
                                                Users
                                            </Link>
                                        </li>

                                    </ul>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            <Link className={`bottom_wrapper_sidebar ${location.pathname === '/my-profile' ? 'active' : ''}`} to='/my-profile'>
                <div className='user_pro_wrapper'>
                    <div className='img_wrapper'>
                        <img src={logomobi} className='logo_img img-fluid' alt='Logo' />
                    </div>
                    <div className='content_wrapper'>
                        <div className='content_wrapper'>
                            {/* <h5>{user?.username}</h5> */}
                            <p>{user?.username}</p>
                        </div>
                    </div>
                </div>
                <div className='icon_wrapper'>
                    <MdKeyboardArrowRight className='icon' />
                </div>
            </Link>
            <div className="sidebar-background" />
        </div>
    )
}

export default Sidebar